var $ = require('../../../../../../../webpack/node_modules/jquery');
var nunjucks = require('../../../../../../../webpack/node_modules/nunjucks');
require('../../../../../../../webpack/node_modules/jscroll');

$(document).ready(function () {
	if(!$('.tx-psr-sortenfinder').length || !window.sortenfinderDetailPluginOnPage) {
		return;
	}
    nunjucks.configure('/template/dist/views-sortenfinder', {autoescape: true});

});

